import axios from '@/plugins/axios';
import SystemConst from '@/shared/system-const';
import { TableFilters } from '@/components/common/common-table-filter.component';

export default {
    namespaced: true,

    state: {
        // 一覧画面用
        /** ページ */
        page: 1,

        /** 表示件数 */
        itemsPerPage: SystemConst.LIST_LINES_PER_PAGE[1],

        /** フィルター条件 */
        filters: {},

        /** ソートカラム */
        sortBy: [],

        /** ソート昇順、降順 */
        sortDesc: [],

        /** 登録・編集・削除画面からの遷移フラグ */
        isFromAdd: false
    },
    mutations: {
        /** セッター：state.page */
        setPage(state: any, page: number) {
            state.page = page;
        },

        /** セッター：state.itemsPerPage */
        setItemsPerPage(state: any, itemsPerPage: number) {
            state.itemsPerPage = itemsPerPage;
        },

        /** セッター：state.filters */
        setFilters(state: any, filters: TableFilters) {
            state.filters = filters;
        },
        
        /** セッター：state.sortBy */
        setSortBy(state: any, sortBy: string[]) {
            state.sortBy = sortBy;
        },
        
        /** セッター：state.sortDesc */
        setSortDesc(state: any, sortDesc: boolean[]) {
            state.sortDesc = sortDesc;
        },

        /** セッター：state.isFromAdd */
        setIsFromAdd(state: any, isFromAdd: boolean) {
            state.isFromAdd = isFromAdd;
        },

        /** 
         * 組織管理ストアのクリア
         * 
         * @param state ステートオブジェクト
         */
        clearStoreState(state: any) {
            state.pageNation = 1;
            state.itemsPerPage = SystemConst.LIST_LINES_PER_PAGE[1];
            state.filters = {};
            state.sortBy = [];
            state.sortDesc = [];
            state.isFromAdd = false;
        }
    },
    actions: {

        // 組織一覧フィルタ条件取得API
        async getFilterConditions() {
            // resultの初期化
            let result: any;

            // URL:GET /api/organizations/filter-conditions
            // params: なし
            await axios.get('/api/organizations/filter-conditions')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            //   HTTPステータスコード
            return result;
        },

        // 一覧表示用組織情報取得API
        async getOrganizations({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/organizations
            await axios.get('/api/organizations',
                {
                    params: data,
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // Excel出力API
        async outputExcel({ state, commit, rootState }: any, data: any) {
            // Excelファイル名の格納
            const fileName = data.fileName;

            // resultの初期化
            let result: any;

            // URL:GET /api/organizations/excel
            // params:作成したAPIのパラメータ
            await axios.get('/api/organizations/excel',
            {
                params: data.params,

                // レスポンスのバイナリデータをarraybufferで受け取る
                responseType: 'arraybuffer'
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;

                    // レスポンス結果のバイナリデータが存在する場合、Excelファイルを作成する
                    if (response.data) {
                        // レスポンス結果のバイナリデータをBlobオブジェクトにする
                        const blob = new Blob([response.data]);

                        // BlobオブジェクトのURLオブジェクトを作成する
                        const objURL: string = window.URL.createObjectURL(blob);

                        // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                        const dlLink: HTMLAnchorElement = document.createElement('a');
                        dlLink.href = objURL;
                        dlLink.download = fileName;

                        // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                        document.body.appendChild(dlLink);

                        // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                        dlLink.click();

                        // 子ノードを削除する
                        document.body.removeChild(dlLink);
                    }
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                    // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                    const errorMessage = Array.from(new Uint8Array(error.response.data));

                    // 作成した文字コードを文字列に変換し、JSON形式に変換する
                    result.data = JSON.parse(String.fromCharCode.apply("", errorMessage));
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // プルダウン情報取得API
        async getPullDowns() {

            // resultの初期化
            let result: any;

            // URL:GET /api/organizations/pull-downs
            await axios.get('/api/organizations/pull-downs')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 登録情報重複チェックAPI
        async checkUnique({ state, commit, rootState }: any, data: any) {

            // resultの初期化
            let result: any;

            // URL:GET /api/organizations/check
            // params:所属コード、組織名称、組織ID(登録処理の場合は空文字)
            await axios.get('/api/organizations/check',
                {
                    params: {
                        affiliationCode: data.affiliationCode,
                        organizationName: data.organizationName,
                        organizationId: data.organizationId
                    }
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 組織登録API
        async addOrganization({ state, commit, rootState }: any, data: any) {

            // resultの初期化
            let result: any;

            // URL:POST /api/organizations
            // params:入力フォームの組織情報
            await axios.post('/api/organizations',
                {
                    organization: data.organization
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 組織情報取得API
        async getOrganization({ state, commit, rootState }: any, data: any) {

            // resultの初期化
            let result: any;

            // URL:GET /api/organizations/{organizationId}
            // organizationId: 組織ID
            await axios.get(`/api/organizations/${data.organizationId}`)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 組織更新API
        async updateOrganization({ state, commit, rootState }: any, data: any) {

            // resultの初期化
            let result: any;

            // URL:PUT /api/organizations/{organizationId}
            // params:入力フォームの組織情報
            await axios.put(`/api/organizations/${data.organizationId}`,
                {
                    organization: data.organization
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 組織情報削除API
        async deleteOrganization({ state, commit, rootState }: any, data: any) {

            // resultの初期化
            let result: any;

            // URL:DELETE /api/organizations/{organizationId}
            // organizationId: 組織ID
            await axios.delete(`/api/organizations/${data.organizationId}`)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },
    },
}
